import { SectionTitle } from '@sleepstation/components'
import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_SPACING } from '@sleepstation/const'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import HubItemsList from '../HubItemsList'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  spacing: [0.75, LAYOUT_SPACING.LARGE],
})``

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const HubSection = ({ title, cards, columns }) => (
  <Layout>
    {title && <SectionTitle>{title}</SectionTitle>}
    <HubItemsList items={cards} columns={columns} />
  </Layout>
)

HubSection.propTypes = {
  title: PropTypes.string.isRequired,
  cards: PropTypes.arrayOf(PropTypes.object).isRequired,
  columns: PropTypes.arrayOf(PropTypes.number),
}

HubSection.defaultProps = {
  columns: [1],
}

export default HubSection
